// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__19dwC","notes":"Notes_notes__3rl9G","note":"Notes_note__1XiRn","markdown":"Notes_markdown__3S7pJ"};